import {Link} from '@remix-run/react';
import {PublicationFile} from '../PublicationFile';

export interface ArticlePublicationListItemProps {
  publication: Research.PublicPublicationDto;
}

export function ArticlePublicationListItem({publication}: ArticlePublicationListItemProps) {
  const metadata = [
    publication.volume ? `Vol. ${publication.volume}` : undefined,
    publication.series ? publication.series : undefined,
    publication.pageStart && publication.pageEnd
      ? `p${publication.pageStart}-${publication.pageEnd}`
      : undefined,
    publication.journal ? publication.journal : undefined,
    publication.issn ? `(ISSN ${publication.issn})` : undefined,
    publication.year,
    publication.doi ? publication.doi : undefined,
  ]
    .filter(Boolean)
    .join(' - ');

  const Markup = (
    <div className="px-2 py-2 flex flex-col w-full">
      <span className="font-semibold text-primary-12">{publication.title}</span>
      <span>{publication.authors}</span>
      <div className="flex gap-2 text-shade-11 text-sm items-center mb-1.5">{metadata}</div>
    </div>
  );

  return (
    <li className="bg-shade-2 rounded overflow-hidden">
      {publication.url ? (
        <Link to={publication.url}>
          <div className="hover:bg-shade-3 w-full">{Markup}</div>
        </Link>
      ) : (
        Markup
      )}
      {publication.file && <PublicationFile file={publication.file} />}
    </li>
  );
}
